import { computed, ComputedRef, isReactive, isRef, Ref } from "vue";
import { useStore } from "vuex";
import { RangeConfigKey } from "../utils/planDatePicker";

export const usePlanSearchRange = (
  defaultLimit = 15,
  configKey: RangeConfigKey = RangeConfigKey.MessagingSearchRange,
  isUnlimitedPlan: Ref<boolean> | ComputedRef<boolean> | boolean = false
) => {
  const unlimited = computed(() => (isRef(isUnlimitedPlan) || isReactive(isUnlimitedPlan)) ? isUnlimitedPlan.value : isUnlimitedPlan);

  const store = useStore();

  const rangeConfig = computed(
    () => store.getters["getDataPlanConfiguration"]?.[configKey]
  );

  const rangeLimit = computed(
    () => !unlimited.value ? rangeConfig.value?.value : defaultLimit
  );

  const typeRange = computed(() =>
    !unlimited.value ? (rangeConfig.value?.format_time === "M"
      ? "months"
      : "days") : "days"
  );

  const rangeLimitText = computed(() => {
    return `${rangeLimit.value} ${
      typeRange.value === "months"
        ? "meses"
        : "días"
    }`;
  });

  return {
    rangeConfig,
    rangeLimit,
    typeRange,
    rangeLimitText,
  };
};